import React, { FC, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { NumberRangeSlider } from "@evergis/ui";
import { useDebouncedCallback } from "@evergis/react";

import { FILTER_UPDATE_DEBOUNCE, RANGE_MAX_VALUE, RANGE_MIN_VALUE } from "./constants";
import { getConfigFilter } from "../../utils/getConfigFilter";
import { useWidgetContext } from "../../../Dashboard/hooks/useWidgetContext";
import { WidgetFilterProps } from "./types";

export const RangeNumberFilter: FC<WidgetFilterProps> = ({ type, filter, config }) => {
  const { t } = useTranslation("featureCard");
  const { filters, changeFilters } = useWidgetContext(type);
  const updateDebounce = useDebouncedCallback(FILTER_UPDATE_DEBOUNCE);

  const { filters: configFilters } = config;
  const { filterName, width, step, label, minValue = RANGE_MIN_VALUE, maxValue = RANGE_MAX_VALUE } = filter.options;
  const filterValue = [filters[filterName]?.min || minValue, filters[filterName]?.max || maxValue] as [number, number];

  const [value, setValue] = useState(filterValue);

  useEffect(() => {
    updateDebounce(() => {
      changeFilters({
        [filterName]: {
          value,
          min: value[0],
          max: value[1],
        },
      });
    });
  }, [value]); // eslint-disable-line

  const configFilter = getConfigFilter(filterName, configFilters);

  if (!configFilter) return null;

  return (
    <NumberRangeSlider
      value={value}
      min={minValue as number}
      max={maxValue as number}
      step={step || 1}
      sliderWidth={width ? `${width}px` : "16.375rem"}
      label={label || t("interval")}
      hasReset
      onChange={setValue}
    />
  );
};
